<script setup lang="ts">
import type { MenuItem } from "@/Modules/App/Models/Domain/MenuItem";
import type { colorTag } from "@/Modules/App/Models/Styles/Colors";

import { TcMenuItem } from "@/Components/UI/index";

import RouterLink from "../Extend/TcRouterLink.vue";

export interface MenuProps {
  items: MenuItem[];
  iconColor?: colorTag;
}

const props = defineProps<MenuProps>();
</script>

<template>
  <ul class="list">
    <RouterLink
      v-for="(item, i) in props.items"
      class="router-link"
      :key="`menu-item-${i}`"
      :to="{ name: item.routeName }"
    >
      <TcMenuItem :label="$t(item.label)" :badge="item.badge" :iconColor="props.iconColor" />
    </RouterLink>
  </ul>
</template>

<style scoped lang="scss">
.router-link {
  text-decoration: none;
}
.list {
  @include sp.padding(l, 4);

  display: flex;
  flex-direction: column;
}
</style>
